<template>
  <div :class="computedClasses" @tap="close" @click.self="close">
    <div class="box" :style="style" @mousedown.stop>
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    fullscreen: {},
    width: {},
    classes: {
      type: String, // Change from Function (or another constructor) to String
      required: false
    }
  },
  computed: {
    computedClasses () {
      let classes = ['modal']

      if (this.fullscreen) {
        classes.push('fullscreen')
      }
      if (this.classes) {
        classes.push(this.classes)
      }

      return classes.join(' ')
    },
    style () {
      return this.width ? 'width: ' + this.width + 'px;' : ''
    }
  },
  methods: {
    close () {
      this.$emit('done', '')
    }
  }
}

</script>

<style scoped lang="scss">

.modal {
  position: fixed;
  z-index: 10000000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.modal {
  padding: 0;
}

.modal .box {
  background-color: white;
  min-width: 340px;
  height: auto;
  max-height: 100%;
  border-radius: 8px;
  overflow: auto;
  padding: 20px;
}

.modal.no-padding .box {
  padding: 0;
  max-width: 95%;
  min-width: 300px;
  overflow: visible;
}

.modal.fullscreen .box {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

</style>
